module.exports = __webpack_public_path__ + "static/media/seed-with-sign.0d29dd50.jpg";